import { Component, signal, inject, ChangeDetectionStrategy } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDialogRef, MatDialogTitle, MatDialogContent, MatDialogActions } from '@angular/material/dialog';
import { ApiService } from 'src/app/services/api.service';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { MatFormField, MatLabel } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';

@Component({
  selector: 'app-new-learning-resource-request-dialog',
  templateUrl: './new-learning-resource-request-dialog.component.html',
  styleUrl: './new-learning-resource-request-dialog.component.css',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    MatDialogTitle,
    FormsModule,
    CdkScrollable,
    MatDialogContent,
    ReactiveFormsModule,
    MatFormField,
    MatLabel,
    MatInput,
    MatDialogActions,
    MatButton,
    MatIcon,
  ],
})
export class NewLearningResourceRequestDialogComponent {
  protected fb = inject(FormBuilder);
  private dialogRef = inject<MatDialogRef<NewLearningResourceRequestDialogComponent>>(MatDialogRef);
  private api = inject(ApiService);

  form: FormGroup;
  readonly saving = signal(false);

  constructor() {
    this.form = this.fb.group({
      title: ['', Validators.compose([Validators.required, Validators.minLength(10)])],
      url: ['', Validators.compose([Validators.required, Validators.pattern(/^https?:\/\/.+/)])],
      price: ['', Validators.compose([Validators.required])],
      observations: ['', Validators.compose([Validators.required, Validators.minLength(10)])],
    });
  }

  submit(): void {
    if (this.form.invalid || this.saving()) return;

    this.saving.set(true);
    this.dialogRef.disableClose = true;

    this.api.createLearningResourceRequest(this.form.value).subscribe({
      next: (): void => this.dialogRef.close(),
      error: (): void => {
        this.saving.set(false);
        this.dialogRef.disableClose = false;
      },
    });
  }
}
